/* RESPONSIBLE TEAM: team-app-security */

import type { SeatType, CopilotSeat } from './types';

export const SEAT_TYPE_OPTIONS: { value: SeatType; labelKey: string }[] = [
  { value: null, labelKey: 'new-settings.workspace.teammates.scim-tab.seat-type.not-set' },
  { value: 'core', labelKey: 'new-settings.workspace.teammates.scim-tab.seat-type.full' },
  { value: 'light', labelKey: 'new-settings.workspace.teammates.scim-tab.seat-type.lite' },
];

export const COPILOT_SEAT_OPTIONS: { value: CopilotSeat; labelKey: string }[] = [
  { value: null, labelKey: 'new-settings.workspace.teammates.scim-tab.copilot-seat.not-set' },
  { value: 'off', labelKey: 'new-settings.workspace.teammates.scim-tab.copilot-seat.off' },
  {
    value: 'included',
    labelKey: 'new-settings.workspace.teammates.scim-tab.copilot-seat.included',
  },
  {
    value: 'unlimited',
    labelKey: 'new-settings.workspace.teammates.scim-tab.copilot-seat.unlimited',
  },
];

export const SCIM_TRANSLATION_KEYS = {
  TAB: {
    TITLE: 'new-settings.workspace.teammates.scim-tab.title',
    DESCRIPTION: 'new-settings.workspace.teammates.scim-tab.description',
    DRAG_TO_REORDER: 'new-settings.workspace.teammates.scim-tab.drag-to-reorder',
    NO_ROLES_AVAILABLE: 'new-settings.workspace.teammates.scim-tab.no-roles-available',
    NO_ROLE_ASSIGNED: 'settings.teammates.role.no-role',
    UNKNOWN_ROLE: 'new-settings.workspace.teammates.scim-tab.unknown-role',
    USERS_COUNT_SHORT: 'new-settings.workspace.teammates.scim-tab.users-count-short',
    USERS_COUNT: 'new-settings.workspace.teammates.scim-tab.users-count',
    USER_ACTIVE: 'new-settings.workspace.teammates.scim-tab.user-active',
    USER_INACTIVE: 'new-settings.workspace.teammates.scim-tab.user-inactive',
    CREATED_AT: 'new-settings.workspace.teammates.scim-tab.created-at',
    UPDATED_AT: 'new-settings.workspace.teammates.scim-tab.updated-at',
    STATE_ACTIVE: 'new-settings.workspace.teammates.scim-tab.state.active',
    STATE_INACTIVE: 'new-settings.workspace.teammates.scim-tab.state.inactive',
    STATE_LABEL: 'new-settings.workspace.teammates.scim-tab.state.label',
    STATE_DESCRIPTION: 'new-settings.workspace.teammates.scim-tab.state.description',
    ROLE_ASSIGNMENT: 'new-settings.workspace.teammates.scim-tab.role-assignment',
    ROLE_ASSIGNMENT_DESCRIPTION:
      'new-settings.workspace.teammates.scim-tab.role-assignment-description',
    ASSIGNED_ROLE: 'new-settings.workspace.teammates.scim-tab.assigned-role',
    USERS_IN_GROUP: 'new-settings.workspace.teammates.scim-tab.users-in-group',
    NO_ROLES_MESSAGE: 'new-settings.workspace.teammates.scim-tab.no-roles-message',
    CREATE_ROLES_FIRST: 'new-settings.workspace.teammates.scim-tab.create-roles-first',
    NO_USERS_TITLE: 'new-settings.workspace.teammates.scim-tab.no-users-title',
    NO_USERS_DESCRIPTION: 'new-settings.workspace.teammates.scim-tab.no-users-description',
    DETAILS_LOAD_ERROR: 'new-settings.workspace.teammates.scim-tab.details-load-error',
    LOAD_ERROR: 'new-settings.workspace.teammates.scim-tab.load-error',
  },
  TABLE: {
    PRIORITY: 'new-settings.workspace.teammates.scim-tab.table.priority',
    GROUP_NAME: 'new-settings.workspace.teammates.scim-tab.table.group-name',
    STATE: 'new-settings.workspace.teammates.scim-tab.table.state',
    ROLE: 'new-settings.workspace.teammates.scim-tab.table.role',
    USERS: 'new-settings.workspace.teammates.scim-tab.table.users',
    SEAT_TYPE: 'new-settings.workspace.teammates.scim-tab.table.seat-type',
    COPILOT_SEAT: 'new-settings.workspace.teammates.scim-tab.table.copilot-seat',
  },
  SEAT_CONFIG: {
    TITLE: 'new-settings.workspace.teammates.scim-tab.seat-configuration',
    DESCRIPTION: 'new-settings.workspace.teammates.scim-tab.seat-configuration-description',
    SEAT_TYPE_LABEL: 'new-settings.workspace.teammates.scim-tab.seat-type.label',
    COPILOT_SEAT_LABEL: 'new-settings.workspace.teammates.scim-tab.copilot-seat.label',
    LITE_SEAT_WARNING: 'new-settings.workspace.teammates.scim-tab.lite-seat-copilot-warning',
    LITE_SEAT_NO_COPILOT_TOOLTIP:
      'new-settings.workspace.teammates.scim-tab.tooltips.lite-seat-no-copilot',
  },
  ACTIONS: {
    CANCEL: 'new-settings.workspace.teammates.scim-tab.actions.cancel',
    APPLY_CHANGES: 'new-settings.workspace.teammates.scim-tab.actions.apply-changes',
    APPLY_SELECTED_CHANGES:
      'new-settings.workspace.teammates.scim-tab.actions.apply-selected-changes',
    DETAILS: 'new-settings.workspace.teammates.scim-tab.actions.details',
    CLOSE: 'new-settings.workspace.teammates.scim-tab.actions.close',
  },
  NO_GROUPS: {
    TITLE: 'new-settings.workspace.teammates.scim-tab.no-groups.title',
    DESCRIPTION: 'new-settings.workspace.teammates.scim-tab.no-groups.description',
  },
  CHANGES_REVIEW: {
    TITLE: 'new-settings.workspace.teammates.scim-tab.changes-review.title',
    DESCRIPTION: 'new-settings.workspace.teammates.scim-tab.changes-review.description',
    CHANGE: 'new-settings.workspace.teammates.scim-tab.changes-review.change',
    MEMBERSHIP: 'new-settings.workspace.teammates.scim-tab.changes-review.membership',
    FROM: 'new-settings.workspace.teammates.scim-tab.changes-review.from',
    TO: 'new-settings.workspace.teammates.scim-tab.changes-review.to',
    ORDER_CHANGE_TITLE:
      'new-settings.workspace.teammates.scim-tab.changes-review.order-change-title',
    ORDER_CHANGED: 'new-settings.workspace.teammates.scim-tab.changes-review.order-changed',
    NO_CHANGES_SELECTED:
      'new-settings.workspace.teammates.scim-tab.changes-review.no-changes-selected',
    TOP_PRIORITY_ALERT:
      'new-settings.workspace.teammates.scim-tab.changes-review.top-priority-alert',
    TOP_PRIORITY_DESCRIPTION:
      'new-settings.workspace.teammates.scim-tab.changes-review.top-priority-description',
    MEMBERSHIP_WARNING:
      'new-settings.workspace.teammates.scim-tab.changes-review.membership-warning',
    MEMBERSHIP_DESCRIPTION:
      'new-settings.workspace.teammates.scim-tab.changes-review.membership-description',
    SEAT_CHANGE_TITLE: 'new-settings.workspace.teammates.scim-tab.changes-review.seat-change-title',
  },
  SUCCESS_MESSAGES: {
    CHANGES_APPLIED: 'new-settings.workspace.teammates.scim-tab.changes-applied-success',
    GROUP_DEACTIVATED: 'new-settings.workspace.teammates.scim-tab.group-deactivated-success',
  },
  ERROR_MESSAGES: {
    CHANGES_APPLIED: 'new-settings.workspace.teammates.scim-tab.changes-applied-error',
    GROUP_DEACTIVATION: 'new-settings.workspace.teammates.scim-tab.group-deactivation-error',
  },
} as const;
